import { twMerge } from 'tailwind-merge'
import { FC, HTMLAttributes } from 'react'

export const Body: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => {
  return (
    <div
      onPointerDownCapture={(evt) => evt.stopPropagation()}
      className={twMerge('px-6 py-4 max-h-[336px] overflow-y-auto', className)}
      {...props}
    />
  )
}
